class EngagementSchedulePicker extends React.Component
{
    constructor(props)
    {
        super(props);
        let [engagementScheduleId, date] =_.split(props.autoSelectEvent, '_');
        this.state = {
            loading: false,
            //month: null,
            selectedDate: date ? moment(date, 'YYYY-MM-DD').toDate() : moment().toDate(),
            selectedTime: null,
            selectedParticipants: null,
            records: [],
            autoSelectDate: date,
            autoSelectEvent: props.autoSelectEvent,
            autoSelectParticipants: props.autoSelectParticipants,
        };
    }

    componentDidMount()
    {
        if(this.state.autoSelectDate){
            this.onMonthChange(moment(this.state.autoSelectDate, 'YYYY-MM-DD').toDate(), true);
        }else{
            this.onMonthChange(moment().toDate());
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // $('.hasTooltip').each(function() { // Notice the .each() loop, discussed below
        //     $(this).qtip({
        //         prerender: true,
        //         content: {
        //             text: $(this).find('.DayPicker-Day-Tooltip').text(),
        //         },
        //         position: {
        //             my: 'bottom center',
        //             at: 'top center',
        //             target: $(this),
        //             viewport: $(window),
        //         },
        //         style: {
        //             classes: 'DayPicker-Day-Tooltip-qTip',
        //             tip: 1,
        //         }
        //     });
        // });
    }

    onMonthChange(date, autoSelect = false)
    {
        this.setState({
            loading: true,
            selectedDate: null,
            selectedTime: null
        });

        axios({
            method: 'get',
            url: SS.route('Processes','EngagementEvents','getEvents', null),
            params: {
                content_item_id: this.props.contentItemId,
                from_date: moment(date).startOf('month').format('YYYY-MM-DD'),
                to_date: moment(date).endOf('month').format('YYYY-MM-DD'),
            }
        })
            .then(response => {
                this.setState({
                    //month: moment(date).month(),
                    records: this.groupRecords(response.data.records),
                });
            })
            .catch(error => {})
            .then(() => {
                this.setState({
                    loading: false,
                    selectedDate: autoSelect ? moment(date).format('YYYY-MM-DD') : null,
                    selectedTime: this.state.autoSelectEvent,
                    selectedParticipants: this.state.autoSelectParticipants,
                });
            });
    }

    groupRecords(records)
    {
        let groupedRecords = {};

        _.each(records, (record) => {
            let date = _.get(record, 'EngagementEvent.schedule_date');
            if(!groupedRecords[date]){
                groupedRecords[date] = [];
            }
            groupedRecords[date].push(_.get(record, 'EngagementEvent'));
        });

        return groupedRecords;
    }

    onDayClick(day, modifiers, event)
    {
        let selectedDate = null;
        if(modifiers.available && !modifiers.selected){
            selectedDate = moment(day).format('YYYY-MM-DD');
        }

        if(modifiers.available || modifiers.full){
            this.setState({
                selectedDate: selectedDate,
                selectedTime: null,
                selectedParticipants: null,
            });
        }
    }

    onDayFocus(day, modifiers, event)
    {
        // let qTipId = $(event.target).data('hasqtip');
        // if(qTipId){
            //$(`#qtip-${qTipId}`).qtip('toggle', true);
        // }
    }

    onTimeChange(event)
    {
        this.setState({
            selectedTime: event.target.value,
            selectedParticipants: null,
        });
    }

    onParticipantsChange(event)
    {
        this.setState({
            selectedParticipants: event.target.value,
        });
    }

    submit(event)
    {
        if(_.isNil(this.props.registrationUrl)){
            return;
        }

        if(this.state.selectedTime){
            window.location.href = this.props.registrationUrl + `?event_code=${this.state.selectedTime}&participants=${this.state.selectedParticipants}`;
        }
    }

    reset(event)
    {
        if(this.state.autoSelectDate || this.state.autoSelectEvent){
            this.setState({
                selectedParticipants: null,
            });
        }else {
            this.setState({
                selectedDate: null,
                selectedTime: null,
                selectedParticipants: null,
            });
        }
    }

    render()
    {
        let available = [];
        let full = [];

        _.each(this.state.records, (events, date) => {
            let spotsAvailable = false;
            _.each(events, (event) => {
                if(event.available > 0){
                    spotsAvailable = true;
                }
            });
            if(spotsAvailable){
                available.push(moment(date, 'YYYY-MM-DD').toDate());
            }else{
                full.push(moment(date, 'YYYY-MM-DD').toDate());
            }
        });

        let dayPickerProps = {
            selectedDays: moment(this.state.selectedDate, 'YYYY-MM-DD').toDate(),
            initialMonth: moment(this.state.selectedDate, 'YYYY-MM-DD').toDate(),
            modifiers: {
                available: available,
                full: full,
            },
            onMonthChange: this.onMonthChange.bind(this),
            onDayClick: this.onDayClick.bind(this),
            //onDayFocus: this.onDayFocus.bind(this),
            renderDay: (day, modifiers) => {
                let available = 0;
                let capacity = 0;
                if(modifiers.available){
                    _.each(this.state.records[moment(day).format('YYYY-MM-DD')], (event, index) => {
                        available += parseInt(event.available);
                        capacity += event.capacity ? parseInt(event.capacity) : 0;
                    });
                }
                return (
                    <div className={`DayPicker-Day-Inner`}>
                        <div className="DayPicker-Day-Date">{moment(day).format('D')}</div>
                        {modifiers.available && <div className="DayPicker-Day-Details desktop">{`${available} of ${capacity} available`}</div>}
                        {modifiers.available && <div className="DayPicker-Day-Details mobile">{`${available} spots`}</div>}
                        {modifiers.full && <div className="DayPicker-Day-Details full">FULL</div>}
                    </div>
                );
            }
        };

        let availableTimeOptions = [];
        let participantOptions = [];

        availableTimeOptions.push(
            <option value="" key={'available-times-blank'}>Select availability</option>
        );

        if(this.state.selectedDate){
            _.each(this.state.records[this.state.selectedDate], (event, index) => {
                let startTime = event.start_time ? moment(event.start_time, 'HH:mm:ss') : false;
                let endTime = event.end_time ? moment(event.end_time, 'HH:mm:ss') : false;
                let optionLabel = [];
                if(event.duration){
                    optionLabel.push(`${event.duration} days`);
                }
                if(startTime){
                    optionLabel.push(`from`);
                    optionLabel.push(startTime.format('h:mma'));
                }
                if(startTime && endTime){
                    optionLabel.push(`to`);
                    optionLabel.push(endTime.format('h:mma'));
                }
                if(!event.duration && !startTime && !endTime){
                    optionLabel.push('all day');
                }
                if(_.size(optionLabel) > 0){
                    optionLabel.push(`-`);
                }
                optionLabel.push(event.available);
                optionLabel.push(`of`);
                optionLabel.push(event.capacity);
                optionLabel.push(`available spots`);
                optionLabel = _.capitalize(_.join(optionLabel, ' '));

                availableTimeOptions.push(
                    <option value={event.event_code} key={'available-times-' + index} disabled={event.available === 0}>{optionLabel}</option>
                );
            });
        }

        participantOptions.push(
            <option value="" key={'participants-blank'}>Select the number of participants</option>
        );

        if(this.state.selectedTime){
            let selectedEvent = _.find(this.state.records[this.state.selectedDate], ['event_code', this.state.selectedTime]);

            let maxParticipants = _.get(selectedEvent, 'available');
            if (this.props.settings.max_participants) {
                maxParticipants = Math.min(maxParticipants, this.props.settings.max_participants);
            }

            for(let i = 0; i < maxParticipants; i++){
                let participants = i + 1;
                participantOptions.push(
                    <option value={participants} key={'participants-' + participants}>{`${participants} participant${participants !== 1 ? 's' : ''}`}</option>
                );
            }
        }

        let selection = 'Please select a date, time and the number of participants.';
        if(this.state.selectedDate && this.state.selectedTime){
            let selectedEvent = _.find(this.state.records[this.state.selectedDate], ['event_code', this.state.selectedTime]);
            let selectedEventDate = moment(this.state.selectedDate, 'YYYY-MM-DD');
            let selectedEventEndDate = selectedEvent.schedule_end_date ? moment(selectedEvent.schedule_end_date, 'YYYY-MM-DD') : null;
            let selectedEventStartTime = (selectedEvent.start_time ? moment(selectedEvent.start_time, 'HH:mm:ss') : false);
            let selectedEventEndTime = (selectedEvent.end_time ? moment(selectedEvent.end_time, 'HH:mm:ss') : false);
            let selectedParticipants = this.state.selectedParticipants || 0;
            //selection = `${selectedParticipants} participant${selectedParticipants !== '1' ? 's' : ''} on ${selectedEventDate} at ${selectedEventStartTime} - ${selectedEventEndTime}`;
            selection = [];
            selection.push(selectedParticipants);
            selection.push(`participant${selectedParticipants !== '1' ? 's' : ''}`);
            selection.push(`on`);
            selection.push(selectedEventDate.format('MMMM Do YYYY'));
            if(selectedEventEndDate && !selectedEventEndDate.isSame(selectedEventDate)){
                selection.push(`until`);
                selection.push(selectedEventEndDate.format('MMMM Do YYYY'));
            }
            if(selectedEventStartTime) {
                selection.push(`at`);
                selection.push(selectedEventStartTime.format('h:mma'));
            }
            if(selectedEventEndTime) {
                selection.push(`-`);
                selection.push(selectedEventEndTime.format('h:mma'));
            }
            selection = _.join(selection, ' ');
        }

        let allowSubmit = this.state.selectedDate && this.state.selectedTime && this.state.selectedParticipants;

        return (
            <div className={['content', (this.state.loading ? 'loading' : '')].join(' ')}>
                {!this.state.autoSelectDate && <div className="title available-dates">Available Dates</div>}
                {!this.state.autoSelectDate && <DayPicker {...dayPickerProps}/>}
                <div className="title available-times">{this.state.autoSelectEvent ? 'Select number of participants' : 'Available Times & Participants'}</div>
                <div className="options">
                    {!this.state.autoSelectEvent &&
                        <select name="times" disabled={!this.state.selectedDate} value={this.state.selectedTime || ''} onChange={this.onTimeChange.bind(this)}>
                            {availableTimeOptions}
                        </select>
                    }
                    <select name="participants" disabled={!this.state.selectedTime} value={this.state.selectedParticipants || ''} onChange={this.onParticipantsChange.bind(this)}>
                        {participantOptions}
                    </select>
                </div>
                <div className="title summary">Your Selection</div>
                <div className="options">
                    <p>{selection}</p>
                </div>
                <div className="actions">
                    <button onClick={this.submit.bind(this)} disabled={!allowSubmit}>CONTINUE</button>
                    <button onClick={this.reset.bind(this)}>RESET</button>
                </div>
            </div>
        );
    }
}

EngagementSchedulePicker.defaultProps = {
    contentItemId: null,
    registrationUrl: null,
    settings: {},
    autoSelectEvent: null,
    autoSelectParticipants: null,
};
EngagementSchedulePicker.displayName = 'EngagementSchedulePicker';